// action - account reducer
export const LOGIN = '@auth/LOGIN';
export const LOGOUT = '@auth/LOGOUT';
export const REGISTER = '@auth/REGISTER';
export const UPDATE_PROFILE = '@auth/UPDATE_PROFILE';
/** Atualiza só `expiresIn` (ex.: após refresh silencioso do token). */
export const SYNC_EXPIRES_IN = '@auth/SYNC_EXPIRES_IN';
